import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_2 = { class: "col-12 col-lg-6 col-xxl-4" }
const _hoisted_3 = { class: "sks placeholder-glow" }
const _hoisted_4 = { class: "sks-cuerpo" }
const _hoisted_5 = { class: "sks-filas" }
const _hoisted_6 = { class: "col-12 col-lg-6 col-xxl-4 mb-4" }
const _hoisted_7 = { class: "sks placeholder-glow" }
const _hoisted_8 = { class: "sks-cuerpo" }
const _hoisted_9 = { class: "sks-filas" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "visually-hidden" }, "Cargando tus suscripciones…", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
        return _createElementVNode("div", {
          key: n,
          class: "mb-4"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "sks-titulo placeholder" }, null, -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "sks-medallon placeholder" }, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (fila) => {
                  return _createElementVNode("div", {
                    key: fila,
                    class: "sks-fila"
                  }, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("span", { class: "sks-etiqueta placeholder" }, null, -1),
                    _createElementVNode("span", { class: "sks-valor placeholder" }, null, -1)
                  ]))])
                }), 64))
              ])
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "sks-pie placeholder" }, null, -1))
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "sks-accion" }, [
            _createElementVNode("span", { class: "sks-precio placeholder" }),
            _createElementVNode("span", { class: "sks-boton placeholder" })
          ], -1))
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "sks-titulo placeholder" }, null, -1)),
        _createElementVNode("div", _hoisted_8, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "sks-medallon placeholder" }, null, -1)),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (fila) => {
              return _createElementVNode("div", {
                key: fila,
                class: "sks-fila"
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("span", { class: "sks-etiqueta placeholder" }, null, -1),
                _createElementVNode("span", { class: "sks-valor placeholder" }, null, -1)
              ]))])
            }), 64))
          ])
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "sks-pie placeholder" }, null, -1))
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "sks-accion" }, [
        _createElementVNode("span", { class: "sks-precio placeholder" }),
        _createElementVNode("span", { class: "sks-boton placeholder" })
      ], -1))
    ])
  ]))
}